export default "__VITE_ASSET__22b1e87e__"